<template>
  <div class="search-history">
    <div class="search-title">
      搜索历史
      <img src="../../../assets/images/home/icon_delete@2x.png" class="icon-del" @click="handleDel" alt="">
    </div>
    <div class="search-tags">
      <div class="tag" v-for="(item, index) in value" :key="index" @click="$emit('search', item)">
        {{ item }}
      </div>
    </div>
    <dialogDel ref="dialogDel" @handleDelSave="handleDelSave" :del-message="messageTip"
               :dialog-ok-btn-title="'删除'"></dialogDel>
  </div>
</template>

<script>
import dialogDel from '@/views/grade/components/dialogDel.vue'

export default {
  props: ['value'],
  components: {
    dialogDel
  },
  data() {
    return {
      messageTip: '',
    }
  },
  created() {
    this.handleGetHistory()
  },
  methods: {
    async handleGetHistory() {
      const historyStr = localStorage.getItem('searchHistory')
      let history = []
      if (historyStr) {
        try {
          history = JSON.parse(historyStr)
        } catch (e) {
          console.error('localStorage 中 searchHistory 数据格式错误:', e)
        }
      }
      this.$emit('input', history)
    },
    handleDelSave() {
      try {
        localStorage.removeItem('searchHistory')
        this.$emit('input', [])
        this.$refs.dialogDel.handleClose()
      } catch (e) {
        console.error('删除搜索历史失败:', e)
      }
    },
    handleDel() {
      this.messageTip = '确认删除最近搜索记录吗?'
      this.$refs.dialogDel.init()
    }
  }
}
</script>

<style scoped lang="less">
.search-title {
  font-family: PingFang HK, PingFang HK;
  margin-top: 24px;
  font-size: 16px;
  padding: 0 14px;
  color: #000000;
  font-weight: 600;
  line-height: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  .icon-del {
    width: 16px;
    height: 16px;
    display: block;
  }
}

.search-tags {
  margin-top: 14px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;

  &.click-more {
    height: auto;
  }

  .tag {
    font-size: 14px;
    width: 100%;
    height: 36px;
    line-height: 36px;
    box-sizing: border-box;
    border-radius: 4px;
    background: rgb(249, 248, 247);
    margin-bottom: 10px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #000000;
    padding-left: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/SearchHistoryList.vue